import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router';

import { Page } from 'components/layout';
import { PageForm } from 'components/blocks/Page';
import CategoryPageScreen from './CategoryPageScreen'


const CategoryPageDetailScreen = ({ history, category, actions, match }) => {
  useEffect(() => {
    actions.category.detailLoad({ id: match.params.categoryId });
  }, [match.params.categoryId, actions.category]);

  const id = match.params.categoryId;
  const detail = category?.detail?.page || {};

  const breadcrumbs = useMemo(() => {
    let result = [{ title: 'Каталог', path: '/catalog' }, { title: 'Категории', path: category.urls.list() }];
    const ancestors = detail.ancestors || [];
    return result.concat(ancestors.map((item) => ({ title: item.name, path: category.urls.detail(item.id) })));
  }, [detail.ancestors, category.urls]);

  return (
    <Page
      isLoading={category.loadDetailStatus.isLoading}
      detail={detail}
      title={`Страница «${detail.h1}»`}
      modelActions={actions.page}
      breadcrumbs={breadcrumbs}
      actions={[
        { mode: 'button', name: 'edit' },
        {
          mode: 'group',
          actions: [{ mode: 'button', name: 'delete' }],
        },
      ]}
      basePath={category.urls.detail(id)}
      tabs={[
        { title: 'Основное', key: 'detail' },
        { title: 'Страница', key: 'page' },
      ]}
    >
      <Route exact path="/catalog/category/:categoryId/page" component={CategoryPageScreen} />

      <PageForm />
    </Page>
  );
};

const mapState = (state) => ({
  category: state.category,
});

const mapDispatch = (dispatch) => ({
  actions: {
    category: dispatch.category,
    page: dispatch.page,
  },
});

export default connect(mapState, mapDispatch)(CategoryPageDetailScreen);
